import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthRoutingModule } from './auth-routing.module';
import { SigninComponent } from './pages/signin/signin.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ResetPasswordComponent } from './pages/reset-password/reset-password.component';
import { RecoverPasswordComponent } from './pages/recover-password/recover-password.component';
import { RecoverPasswordModalComponent } from './pages/recover-password/recover-password-modal/recover-password-modal.component';

@NgModule({
  declarations: [SigninComponent, ResetPasswordComponent, RecoverPasswordComponent, RecoverPasswordModalComponent],
  imports: [CommonModule, AuthRoutingModule, FormsModule, ReactiveFormsModule]
})
export class AuthModule {}
